import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Lock, Loader2, ArrowLeft } from "lucide-react";
import { authApi, setToken, formatApiError } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function AdminLogin() {
    const nav = useNavigate();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const { data } = await authApi.post("/auth/login", { email, password });
            setToken(data.access_token);
            toast.success("Connexion réussie");
            nav("/admin");
        } catch (err) {
            toast.error(formatApiError(err));
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen bg-ink flex items-center justify-center p-6">
            <div className="w-full max-w-md">
                <a
                    href="/"
                    className="inline-flex items-center gap-2 text-white/60 hover:text-white text-xs uppercase tracking-widest mb-8"
                >
                    <ArrowLeft className="w-4 h-4" />
                    Retour au site
                </a>

                <div className="bg-white border-2 border-signal">
                    <div className="p-8 border-b border-slate-100">
                        <div className="w-12 h-12 bg-ink flex items-center justify-center mb-4">
                            <Lock className="w-5 h-5 text-signal" strokeWidth={2} />
                        </div>
                        <h1 className="font-display font-black text-3xl tracking-tighter text-ink">
                            Espace admin
                        </h1>
                        <p className="text-sm text-slate-500 mt-2">
                            Modération des avis Carvaelis.
                        </p>
                    </div>
                    <form onSubmit={submit} className="p-8 space-y-5">
                        <div className="space-y-2">
                            <Label
                                htmlFor="email"
                                className="text-xs uppercase tracking-wider font-bold text-ink"
                            >
                                Email
                            </Label>
                            <Input
                                id="email"
                                type="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                data-testid="admin-login-email"
                                required
                                autoComplete="username"
                                className="rounded-none border-slate-300 focus-visible:ring-signal focus-visible:ring-offset-0 focus-visible:border-signal h-11"
                            />
                        </div>
                        <div className="space-y-2">
                            <Label
                                htmlFor="password"
                                className="text-xs uppercase tracking-wider font-bold text-ink"
                            >
                                Mot de passe
                            </Label>
                            <Input
                                id="password"
                                type="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                data-testid="admin-login-password"
                                required
                                autoComplete="current-password"
                                className="rounded-none border-slate-300 focus-visible:ring-signal focus-visible:ring-offset-0 focus-visible:border-signal h-11"
                            />
                        </div>
                        <button
                            type="submit"
                            disabled={loading}
                            data-testid="admin-login-submit"
                            className="w-full flex items-center justify-center gap-2 bg-signal hover:bg-signal-dark disabled:opacity-60 text-white px-6 py-4 font-bold uppercase tracking-wider text-sm transition-colors"
                        >
                            {loading ? (
                                <>
                                    <Loader2 className="w-4 h-4 animate-spin" />
                                    Connexion...
                                </>
                            ) : (
                                "Se connecter"
                            )}
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
}
